import React from 'react'
import Style from './Aboutme.module.css'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import logo from '../img/khodal jari.png'
import quality from '../img/quality-removebg-preview.jpg'
import time from '../img/vision.jpg'
import swachh from '../img/swachh-bharat-abhiyaan.jpg'
import socily1 from '../img/socially01.jpg'
import socily2 from '../img/socially02.jpg'
import Carousel from 'react-bootstrap/Carousel';
import hands from '../img/hand-895588_1920.jpg';


const Aboutme = () => {
    return (
        <>
            {/* section1 */ }
            <div className={ Style.main }>
                <Container className={ Style.row1 }>
                    <Row>
                        <Col sm={ 12 } xs={ 12 } lg={ 6 } md={ 12 } className={ Style.logo }>
                            <img src={ logo } alt="" />
                        </Col>

                        <Col sm={ 12 } lg={ 6 } xs={ 12 } md={ 12 }>
                            <br /><h2 className={ Style.about }>ABOUT THE COMPANY</h2><br /><br />
                            <h6>👉Khodal Jari was incorporated in 2007 inspired by unique advantages of providing high quality of Metallic Yarn with the unique name of "Khodal jari". We believe in delivering valuable and dependable solutions based on high end technology in the benefit of the textile industry.</h6><hr /><br />

                            <h6>👉Khodal jari Committed to deliver the the best quality products, we give paramount importance to it. We feel proud to say that we are producing the most different colours in the whole world.</h6><hr /><br />

                            <h6>👉The firm is using high quality of machinery in order to maintain the quality of product and because of providing qualitative product its selling is spread all over the world. The motto of firm is to provide "quality, range and economy"</h6><hr />
                        </Col>
                    </Row>

                </Container>

                {/* section2 */ }
                <Container className={ Style.row1 }>
                    <br /><hr /><br />
                    <Row>
                        <Col sm={ 12 } lg={ 6 } xs={ 12 } md={ 12 }>
                            <br /><h2 className={ Style.about }>Quality Assurance</h2><br /><br />
                            <h6>👉As a policy, 'Quality Comes First' implements a quality system with the quality and commitment of products to adopt. We use latest and world-class tools in the laboratory to check raw materials and final products.</h6><hr /><br />

                            <h6>👉We try to develop a range of metal yarn which focuses on quality in all respects. Our products are popular in order to follow all the standards applicable to the textile industry and to exceed all standards. To ensure that consumers deliver the best quality products, we examine each unit made in our in-house facility. In this way, we have established an advanced quality control laboratory, where the experiments are performed by imitating, which evaluates to the characteristics of perfect fit, neat stitching, compression resistance and colour stability.</h6><hr /><br />


                        </Col>

                        <Col sm={ 12 } xs={ 12 } lg={ 6 } md={ 12 } className={ Style.logo }>
                            <img src={ quality } alt={ quality } />
                        </Col>
                    </Row>

                </Container>

                {/* section3 */ }
                <Container className={ Style.row1 }>
                    <br /><hr /><br />
                    <Row>
                        <Col sm={ 12 } xs={ 12 } lg={ 6 } md={ 12 } className={ Style.logo }>
                            <img src={ time } alt={ time } />
                        </Col>

                        <Col sm={ 12 } lg={ 6 } xs={ 12 } md={ 12 }>
                            <br /><h2 className={ Style.about }>Vision</h2><br /><br />
                            <h6>👉At Khodal, our focus is to develop jari that are of higher quality as well as affordable to our clients.</h6><hr /><br />

                            <h6>👉We are at the forefront of providing quality material that improves the quality of embroidery work done by machine which help client to have trust in our brands.</h6><hr /><br />

                        </Col>


                    </Row>

                </Container>

                {/* section4 */ }

                <Container className={ Style.row1 }>
                    <br /><hr /><br />
                    <Row>
                        <Col sm={ 12 } lg={ 6 } xs={ 12 } md={ 12 }>
                            <br /><h2 className={ Style.about }>Socially</h2><br /><br />
                            <h6>👉Mahatma Gandhi said cleanliness is next to healthiness. Mahatma Gandhi during his lifespan passed message to whole society to keep their city and home clean. Today on the footprint of Mahatma Gandhi our Honourable Prime Minister started a clean Indian mission.</h6><hr /><br />

                            <h6>👉The company is oblige to clean India and also provide clean Environment, security, addiction free and health awakening among the employees. We aim to be a responsible corporate citizen of the country. We strive to meet the highest standards of environmental and social responsibility and to respect local customs and practices.</h6><hr /><br />


                        </Col>

                        <Col sm={ 12 } xs={ 12 } lg={ 6 } md={ 12 } className={ Style.logo }>
                            {/* <img src={ quality } alt={ quality } /> */ }

                            <Carousel>
                                <Carousel.Item>
                                    <img
                                        className="d-block w-100"
                                        src={ swachh }
                                        alt="First slide"
                                    />
                                </Carousel.Item>

                                <Carousel.Item>
                                    <img
                                        className="d-block w-100"
                                        src={ socily1 }
                                        alt="Second slide"
                                    />
                                </Carousel.Item>

                                <Carousel.Item>
                                    <img
                                        className="d-block w-100"
                                        src={ socily2 }
                                        alt="Third slide"
                                    />
                                </Carousel.Item>
                            </Carousel>
                        </Col>
                    </Row>

                </Container>

                {/* section5 */ }

                <Container className={ Style.row1 }>
                    <br /><hr /><br />
                    <Row>
                        <Col sm={ 12 } xs={ 12 } lg={ 6 } md={ 12 } className={ Style.logo }>
                            <img src={ hands } alt={ hands } />
                        </Col>

                        <Col sm={ 12 } lg={ 6 } xs={ 12 } md={ 12 }>
                            <br />
                            <h2 className={ Style.about }>Vision</h2>
                            <br /><br />
                            <span><h4>👉High Quality :-</h4><i>Khodal jari superb threads add additional texture and details to your design.</i></span>
                            <hr /><br />
                            <span><h4>👉Competitive Pricey :-</h4><i>xquisite thread quality with a fair price</i></span>
                            <hr /><br />
                            <span><h4>👉Awesome Team :-</h4><i>Professional sales offer you efficient solutions to your problem.</i></span>
                            <hr /><br />


                          
                        </Col>


                    </Row>

                </Container>
            </div>



        </>
    )
}

export default Aboutme
